export default "__VITE_ASSET__1cf5fa65__"